import {GeneralStockModel} from "./generalstock.model";

export default class PollStock
{
    question: string | undefined;
    stock: GeneralStockModel[] = [];
}